import { render, staticRenderFns } from "./WebEmail.vue?vue&type=template&id=148b29e8&"
import script from "./WebEmail.vue?vue&type=script&lang=js&"
export * from "./WebEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('148b29e8')) {
      api.createRecord('148b29e8', component.options)
    } else {
      api.reload('148b29e8', component.options)
    }
    module.hot.accept("./WebEmail.vue?vue&type=template&id=148b29e8&", function () {
      api.rerender('148b29e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/WebEmail/WebEmail.vue"
export default component.exports